import { render, staticRenderFns } from "./ResponseBlock.vue?vue&type=template&id=4e4a10bf&scoped=true&"
import script from "./ResponseBlock.vue?vue&type=script&lang=js&"
export * from "./ResponseBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4a10bf",
  null
  
)

export default component.exports